// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12Unx","label":"styles_label__1elJe"};